import React, {Component} from 'react';
import PropTypes from "prop-types";
import Select from 'react-select';


class OutlierSelector extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired,
    };

    static defaultProps = {
        currentOption: 0,
        options: [0, 10, 20, 30]
    };

    constructor(props) {

        super(props);

        this.translate = this.props.baseData.translate;

        this.state = {
            currentOption: (this.checkSelectedOption(props.currentOption)) ? props.currentOption : 0
        };

        this.selectOption = this.selectOption.bind(this);

    }

    checkSelectedOption(opt) {

        return (this.props.options.indexOf(parseInt(opt)) >= 0);

    }

    selectOption(opt) {

        if (!opt || !this.checkSelectedOption(opt.value)) return null;

        this.setState({currentOption: opt.value});

        if (this.props.onChange) this.props.onChange(opt.value);

    }

    getOptions() {

        const options = this.props.options;
        const opts = [];

        for (let ix in options) {
            let opt = options[ix];

            opts.push({
                value: opt,
                label: String(opt) + ' %',
            });
        }

        return opts;

    }

    render() {
        const opts = this.getOptions();
        const selectedOption = opts.find(o => o.value === this.state.currentOption) || null;

        return (
            <Select
                name="form-field-ignore-outliers"
                className="chosen-container chosen-container-single"
                style={{width: '260px'}}
                options={opts}
                onChange={this.selectOption}
                value={selectedOption}
                placeholder={this.translate('select') + '...'}
                clearable={false}
                noResultsText={this.translate('noResultsFound')}
            />
        );
    }

}

export default OutlierSelector;